import { Delete } from '../helpers';
import { createPath } from './utils';

export function RevokeAccess(channel: number, email: string) {
  return Delete<{ message: string }>({
    path: createPath(`${channel}/user`),
    body: { email },
  });
}
